import browserUpdate from 'browser-update';

browserUpdate({
  notify: {
    i: 11,
    f: -4,
    o: -4,
    s: -2,
    c: -5
  },
  insecure: true,
  unsupported: false,
  api: 5
});
